export const generateWidgetInnerContentId = (widgetId: string) => {
  return `${widgetId}-widget-inner-content`;
};
